export default __webpack_public_path__ + "static/media/btn-less.9de417c5.svg";